/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getList = (payload = { sort_by: 'desc' }, callback) =>
  req.list(c.GET_SETTINGS, '/api/v1/administrators/cms', payload, callback);

export const getPaperList = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_PAPER_SETTINGS,
    '/api/v1/administrators/cms',
    payload,
    callback
  );

export const getCedulaInterest = (payload = { sort_by: 'desc' }, callback) =>
  req.item(
    c.GET_CEDULA_INTEREST,
    '/api/v1/administrators/cedula_settings/interest_rates',
    payload,
    callback
  );

export const updateCedulaInterest = (payload, callback) =>
  req.update(
    c.UPDATE_CEDULA_INTEREST,
    '/api/v1/administrators/cedula_settings/interest_rates',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const showUserManagement = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_SETTING,
    `/api/v1/administrators/cms/${id}`,
    payload,
    callback
  );

export const create = (payload, callback) =>
  req.create(
    c.CREATE_SETTING,
    '/api/v1/administrators/cms',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const update = (id, payload, callback) =>
  req.create(
    c.UPDATE_SETTING,
    `/api/v1/administrators/cms/${id}`,
    { ...payload, _method: 'PUT' },
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeSettings = (id, payload, callback) =>
  req.remove(
    c.REMOVE_SETTING,
    `/api/v1/administrators/cms/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );

export const getRoleList = (
  payload = { is_paginated: 1, sort_by: 'desc' },
  callback
) =>
  req.list(c.GET_ROLE_LIST, '/api/v1/administrators/roles', payload, callback);

export const getCms = () =>
  req.list(
    'CMS',
    '/api/v1/taxpayers/cms' // site api ep
  );

export const deleteTemplate = (cmsID, templateKey, callback) =>
  req.remove(
    c.REMOVE_TEMPLATE,
    `/api/v1/administrators/cms/${cmsID}/templates/${templateKey}`,
    () => {
      alert.success('Template successfully removed!');
      if (callback) callback();
    }
  );
